/**
 * This module contains the UI
 * to build the trigger instruction category
 */

// TODO:
// - reduce unneeded notifications
// - unbind events of removed UI elements
// - unify styles

(function() {
  const $ = require('jQuery');
  const instruction_widgets = require('../instruction_widgets');
  const icons = require('../../icons');
  const widgets = require('../widgets');
  const utils = require('./utils');

  function create(pParameters) {
    const lLibrary = pParameters.library;
    const lApp = pParameters.application;
    const lSequence = pParameters.sequence;
    const lInstruction = pParameters.instruction;
    const _lDiv = $('<div class="ml_instruction h_layout"/>');
    const _lCard = widgets.card(icons[lInstruction.getCategory()], function () {
      lSequence.removeInstruction(lSequence.getInstructionIndex(lInstruction));
    }).attr('id', widgets.idGenerator.nextInstructionId());
    const _lParameterMap = {};
    let _lFilteredActionsSet;
    // Note (alevy): this function does not return a widget
    // it adds widgets to _lCard
    const _parameterWidget = function (pParameterInfo, pParameter) {
      let _lWidget;

      switch (pParameterInfo.format) {
        // Note(alevy): This is to build
        // the generate event instruction
        case 'string':
          if (pParameterInfo.unit == 'sequenceName') {
            _lWidget = instruction_widgets.sequenceListWidget(pParameterInfo.name, lApp, lSequence, pParameterInfo.description, lInstruction.getParameter(pParameter), function (pValue) {
              lInstruction.setParameter(pParameter, pValue);
            }, lInstruction.mName);
          }
          break;

        default:
          _lWidget = widgets.baseWidget(pParameterInfo.name).append($('<div>' + pParameterInfo.format + ' not supported</div>'));
          break;
      }

      if (_lWidget) {
        _lWidget.addClass('v_layout spaced');
        _lParameterMap[pParameter] = _lWidget;
        _lCard.parameters.append(_lWidget);
      }
    };
    const _lActionSet = lLibrary.getInstructionSet()[lInstruction.getCategory()];
    let _lActions;
    const _onAction = function (pAction) {
      const lIsMachineApp = lApp.mIsMachineApp;
      const _restrictAction = function () {
        const lParameterLengthIsZero = _lActionSet[lInstruction.mName].parameters.length === 0;
        const lMessage = lIsMachineApp
          ? 'Add a non-locked child sequence before using this instruction.'
          : 'Add a child sequence before using this instruction. ';
        if(lParameterLengthIsZero) {
          widgets.messageBox(`${lMessage} Your changes have been reverted.`, 'warning');
          lInstruction.setName(lInstruction.mName);
        } else {
          widgets.messageBox(`${lMessage}`, 'warning');
          lInstruction.setName('terminate');
        }
      };
        // checks if there are any paramaters that should be set
        // if 0, then it is okay to proceed. Otherwise, check if there are child sequences. See below.
      if (_lActionSet[pAction].parameters.length === 0){
        return lInstruction.setName(pAction);
      }

      //get all sequences that are unlocked, are not the main sequence, and are not the current sequence
      const lFilteredSequences = lApp.listSequences()
        .map(pSequenceName => lApp.getSequence(pSequenceName))
        .filter(pSequence => {
          return (
            !pSequence.getIsLocked()
              && lApp.getInitialSequence().getName() != pSequence.getName()
              && lSequence.getName() != pSequence.getName()
          );
        });

      if(lFilteredSequences.length == 0) {
        _restrictAction();
      }
      else {
        lInstruction.setName(pAction);
      }

    };
    const buildInstruction = utils.buildInstruction(_parameterWidget);

    _lCard.icon.find('h5').addClass('ml_number');
    _lCard.icon.removeClass('ml_icon').addClass('ml_icon_instruction_widget');


    if (_lActionSet) {
      const lReplaceCategory = utils.replaceCategory(lInstruction.getCategory());
      _lFilteredActionsSet = utils.getActions(lLibrary, lInstruction);
      _lActions = widgets.listWidget(lReplaceCategory, utils.getActionList(_lFilteredActionsSet), 'Action to be performed', lInstruction.getName(), _onAction);
      buildInstruction(_lCard, lInstruction, _lActions, _lFilteredActionsSet);
      _lCard.append($('<div class="ml_animated_background"/>'));
      _lDiv.append(_lCard);

      const lInstructionListeners = utils.getInstructionListener({
        actions: _lActions,
        buildInstruction: buildInstruction,
        card: _lCard,
        filteredActionsSet: _lFilteredActionsSet,
        instruction: lInstruction,
        library: lLibrary,
        parameterMap: _lParameterMap,
      });

      // Instruction and Application listeners
      lInstruction.addListener(lInstructionListeners);

      _lDiv.on('remove', function onRemoveTriggerInstruction() {
        lInstruction.removeListener(lInstructionListeners);
      });
    }


    return _lDiv;
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    create: create,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
})();
